// @flow
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { createUseStyles } from 'react-jss';

type Props = {
  show: boolean,
  children: React.Element<any> | React.Element<any>[]
}

const useStyles = createUseStyles({
  transition: {
    opacity: '0',
    transform: 'translateY(100%)',
    '&.transition-enter': {
      opacity: '0',
      transform: 'translateY(100%)'
    },
    '&.transition-enter-active, &.transition-enter-done': {
      opacity: '1',
      transform: 'none',
      transition: 'opacity, transform',
      transitionDuration: '.6s',
      transitionDelay: '.6s',
      transitionTimingFunction: 'ease-in'
    }
  }
});

const SlideUpFadeIn = (props: Props) => {
  const { children, show = true } = props;
  const c = useStyles();

  return (
    <CSSTransition
      in={show}
      classNames="transition"
      timeout={{ enter: 1200 }}
    >
      <div className={c.transition}>
        {children}
      </div>
    </CSSTransition>
  );
};

export default SlideUpFadeIn;
